@if (content() === 'all' && categoryService.ofCurrentCenter().length) {
  <div class="layout border-t border-gray-200 py-2">
    <div class="bg-white flex gap-4 items-center overflow-x-scroll scrollbar-hide relative">
      <div (click)="scrollLeft()"
           (keyup.enter)="emulateClick($event)"
           tabindex="0"
           [class.hover:border-100cielsGift-100]="giftMode()"
           [class.hover:border-100ciels-300]="!giftMode()"
           [class.hover:stroke-100cielsGift-100]="giftMode()"
           [class.hover:stroke-100ciels-300]="!giftMode()"
           class="p-1 rounded-full border border-gray-300 stroke-gray-300 hidden md:block cursor-pointer">
        <svg class="w-4 h-4"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 32 32" aria-hidden="true" role="presentation"
             focusable="false"
             style="display: block; fill: none; stroke-width: 5.33333; overflow: visible;">
          <path fill="none" d="M20 28 8.7 16.7a1 1 0 0 1 0-1.4L20 4"></path>
        </svg>
      </div>

      <div #scrollContainer
           class="bg-white flex gap-2 items-center overflow-x-scroll scrollbar-hide relative scroll-smooth">

        @for (c of categoryService.ofCurrentCenter(); track c.id) {
          <button class="flex flex-col items-center p-4 rounded aspect-square"
                  [ngClass]="{
  'bg-100ciels-300': c.id === category()?.id && !giftMode(),
  'bg-100ciels-500': c.id === category()?.id && giftMode()
}"
                  (click)="switchCategory(c)"
                  (keyup.enter)="emulateClick($event)">
            <img [ngSrc]="categoryIcon(c)" width="64" height="64"
                 alt="" class="w-8 h-8 md:h-10 md:w-10">
            <span class="text-sm md:text-base mt-2 whitespace-nowrap"
                  [class.text-100cielsGift-100]="giftMode()"
                  [class.text-100ciels-300]="!giftMode()"
                  [ngClass]="{'text-white': c.id === category()?.id}">{{ 'category/' + c.id + '/name' | translate }}</span>
          </button>
        }
      </div>
      <div (click)="scrollRight()"
           (keyup.enter)="emulateClick($event)"
           tabindex="0"
           [class.hover:border-100cielsGift-100]="giftMode()"
           [class.hover:border-100ciels-300]="!giftMode()"
           [class.hover:stroke-100cielsGift-100]="giftMode()"
           [class.hover:stroke-100ciels-300]="!giftMode()"
           class="p-1 rounded-full border border-gray-300 stroke-gray-300 hidden md:block cursor-pointer">
        <svg class="w-4 h-4" viewBox="0 0 32 32" aria-hidden="true" role="presentation"
             focusable="false"
             style="display: block; fill: none;stroke-width: 5.33333; overflow: visible;">
          <path fill="none" d="m12 4 11.3 11.3a1 1 0 0 1 0 1.4L12 28"></path>
        </svg>
      </div>
    </div>
  </div>
}

<div [class.bg-100ciels-100]="!giftMode()"
     [class.bg-100ciels-600]="giftMode()"
     [class.h-full]="content() !== 'all' && content() !== 'minimal'">
  <div class="layout py-16 lg:pt-24">
    @if (content() === 'all' || content() === 'minimal') {
      <h2 class="font-semibold text-3xl leading-tight mb-8" [class.text-white]="giftMode()"
          [class.text-100ciels-500]="!giftMode()"
          [innerHtml]="title() | translate : { center: center()!.name } | byPass"></h2>
      <div class="flex gap-6 mt-10 items-start">
        <div class="flex gap-2 md:gap-6 overflow-x-auto scrollbar-hide items-start">
          <button
            (click)="switchUniverse(null)"
            (keyup.enter)="emulateClick($event)"
            class="group relative flex-[0_0_45%] md:flex-auto min-w-48 py-2 c overflow-hidden rounded-lg text-lg"
            [class.bg-100ciels-100]="giftMode()"
            [class.bg-white]="!giftMode()">
            <div
              [ngClass]="{'w-full': universe() === null}"
              class="absolute inset-0 w-0 transition-all duration-[350ms] ease-out bg-100ciels-300 group-hover:w-full"></div>
            <span
              [ngClass]="{
                  'text-100ciels-500': !!universe(),
                  'text-white': !universe() ,
                  }"
              class="group-hover:text-white relative uppercase font-semibold text-sm md:text-base">{{ 'all' | translate }}</span>
          </button>
          <button
            (click)="togglePromo()"
            (keyup.enter)="emulateClick($event)"
            class="group relative min-w-48 py-2 px-2 md:px-8 overflow-hidden rounded-lg bg-100ciels-500 text-lg flex-[0_0_45%] md:flex-auto">
            <div
              [ngClass]="{'w-full': promo()}"
              class="absolute inset-0 w-0 transition-all duration-[350ms] ease-out group-hover:w-full bg-100ciels-300"
            ></div>

            <span
              class="relative text-white uppercase font-medium text-sm md:text-base">{{ 'promotion' | translate }}</span>
          </button>
          @for (u of universeService.universes(); track u.id) {
            <button
              (click)="switchUniverse(u)"
              (keyup.enter)="emulateClick($event)" [ngClass]="{'pb-5 rounded-b-none': universe()?.id === u.id}"
              class="bg-white group relative min-w-48 py-2 px-2 md:px-8 overflow-hidden rounded-lg text-lg flex-[0_0_45%] md:flex-auto"
            >
              <div
                [ngClass]="{'w-full': universe()?.id === u.id}"
                class="absolute inset-0 w-0 transition-all duration-[350ms] ease-out bg-100ciels-300 group-hover:w-full"></div>
              <span
                [ngClass]="{
                  'text-100ciels-500': universe()?.id !== u.id,
                  'text-white': universe()?.id === u.id,
                  }"
                class="group-hover:text-white relative uppercase font-semibold text-sm md:text-base">{{ 'universe/' + u.id + '/name' | translate }}</span>
            </button>
          }
        </div>
        <div appAutoClose="always" class="relative inline-block text-left">
          <button>
            @if (giftMode()) {
              <img class="w-8" alt="" width="32" height="32" ngSrc="assets/icons/dark/filter.svg">
            } @else {
              <img class="w-8" alt="" width="32" height="32" ngSrc="assets/icons/dark/filter.svg">
            }
            <span class="sr-only">Sort</span>
          </button>
          <ul
            class="py-3 absolute right-0 z-10 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="0">
            <li
              (click)="switchSort('inc')"
              (keyup.enter)="emulateClick($event)"
              [ngClass]="sort() === 'inc' ? 'bg-gray-100 text-gray-900' : 'text-gray-700'"
              class="cursor-pointer flex items-center gap-6 px-8 py-2 text-sm "
              [class.hover:bg-100cielsGift-100]="giftMode()"
              [class.hover:bg-100ciels-100]="!giftMode()"
              role="menuitem" tabindex="0">
              <div class="w-8">
                @if (giftMode()) {
                  <img alt="" class="w-3 mx-auto" width="32" height="32"
                       ngSrc="assets/icons/dark/increasing.svg">
                } @else {
                  <img alt="" class="w-3 mx-auto" width="32" height="32"
                       ngSrc="assets/icons/dark/increasing.svg">
                }
              </div>
              {{ 'increasingPrices' | translate }}
            </li>
            <li
              (click)="switchSort('dec')"
              (keyup.enter)="emulateClick($event)"
              [ngClass]="sort() === 'dec' ? 'bg-gray-100 text-gray-900' : 'text-gray-700'"
              class="cursor-pointer text-gray-700 flex items-center gap-6 px-8 py-2 text-sm "
              [class.hover:bg-100cielsGift-100]="giftMode()"
              [class.hover:bg-100ciels-100]="!giftMode()"
              role="menuitem" tabindex="0">
              <div class="w-8">
                @if (giftMode()) {
                  <img alt="" class="w-3 mx-auto" width="32" height="32" ngSrc="assets/icons/dark/decreasing.svg">
                } @else {
                  <img alt="" class="w-3 mx-auto" width="32" height="32" ngSrc="assets/icons/dark/decreasing.svg">

                }
              </div>
              {{ 'decreasingPrices' | translate }}
            </li>
            <!--
            <li
              (click)="filter.set('promo')"
              (keyup.enter)="emulateClick($event)"
              [ngClass]="filter() === 'promo' ? 'bg-gray-100 text-gray-900' : 'text-gray-700'"
              class="text-gray-700 flex items-center gap-6 px-8 py-2 text-sm hover:bg-100ciels-300 hover:bg-opacity-10"
              role="menuitem" tabindex="0">
              <img alt="" class="w-8" width="32" height="32" ngSrc="assets/icons/dark/gift.svg">
              {{ 'giftVouchers' | translate }}
            </li>
            -->
          </ul>
        </div>
      </div>

      @if (universe(); as universe) {
        <div
          class="bg-white rounded-lg flex gap-4 md:gap-2 flex-col md:flex-row px-3 md:px-5 py-3 overflow-x-auto md:-mr-5 scrollbar-hide">
          @for (a of universe.activities; track a.id) {
            <button
              (click)="switchActivity(a)"
              (keyup.enter)="emulateClick($event)"
              class="flex gap-2 items-center hover:bg-opacity-10 px-4 rounded-lg group cursor-pointer"
              [class.hover:bg-100cielsGift-100]="giftMode()"
              [class.hover:bg-100ciels-300]="!giftMode()"
              [class.text-100cielsGift-100]="giftMode()"
              [class.text-100ciels-300]="!giftMode()"
              [ngClass]="{
  '!bg-100ciels-300': a.id === activity()?.id && !giftMode(),
  '!bg-100cielsGift-100': a.id === activity()?.id && giftMode()
}">
              <img width="32" height="32" class="w-10" alt="" [ngSrc]="activityIcon(a)">
              <p class="uppercase font-semibold whitespace-nowrap item text-left"
                 [class.text-100cielsGift-100]="giftMode()"
                 [class.text-100ciels-500]="!giftMode()"
                 [class.group-hover:text-100cielsGift-100]="giftMode()"
                 [class.group-hover:text-100ciels-300]="!giftMode()"

                 [ngClass]="{'!text-white': a.id === activity()?.id}">
                {{ 'universe/' + universe.id + '/activity/' + a.id + '/name' | translate }}
              </p>
            </button>
          }
        </div>
      }
    }
    @if (content() !== 'all' && content() !== 'minimal') {
      <h2 class="text-xl text-white font-semibold -mb-12">{{ 'selectVariant' | translate }}</h2>
    }
    <div class="grid md:grid-cols-2 lg:grid-cols-3 auto-rows-fr gap-x-4 gap-y-8 mt-16">
      @for (product of products(); track product.id) {
        <app-product-card [product]="product" [gift]="giftMode()"></app-product-card>
      }
    </div>

    @if (content() === 'minimal') {
      <div class="grid md:grid-cols-3 gap-x-4 mt-10">
        @if (!giftMode()) {
          <a appHoverGradient
             [routerLink]="['/offers']"
             class="big-btn py-4 text-base lg:col-start-2 col-span-3 lg:col-span-1 flex justify-center items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white"
                 class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
            </svg>

            {{ 'showMore' | translate }}
          </a>
        } @else {
          <a appHoverGradientGreen
             [routerLink]="['/offers']"
             class="big-btn py-4 text-base col-start-2 flex justify-center items-center gap-2 bg-100cielsGift-100">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white"
                 class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
            </svg>

            {{ 'showMore' | translate }}
          </a>
        }
      </div>
    }
  </div>
</div>
